import { IdpUser } from "types/IdpUser";

const RNP_DS_ENTITY_ID = process?.env?.REACT_APP_RNP_DS_ENTITY_ID ?? "https://idp.rnp.br/idp/shibboleth";

export function getFixedIdp(federatedUserDetails: IdpUser | null){
    if(federatedUserDetails?.identityProvider.idpId === RNP_DS_ENTITY_ID){
      return undefined;
    }
    if(federatedUserDetails?.role === "ADMIN"){
      return federatedUserDetails?.identityProvider ?? undefined
    }
  
}
